(function ($) {
    $(window).on("load", function (e) {
        var sectionName = $(".form-with-cta"), sectionColor = sectionName.attr("data-color"); sectionName.removeAttr("data-color");
        if (sectionColor != "") { sectionName.css("background-color", sectionColor); } sectionName.css("opacity", 1);
        // var headerID = $("header").attr("id");sectionName.addClass(headerID);
        // var sectionBg2 = $('.banner-third-level.we-default').css("background-color");
        // if ($('section').hasClass("banner-third-level") && sectionBg2 === "rgb(0, 0, 0)" || sectionBg2 === "rgb(0, 6, 15)") {
        //     $("header").addClass('text-white');
        // }
    });
})(jQuery);